import rootReducer from "./root-reducer";
import { configureStore } from "@reduxjs/toolkit";
import { filterPersistenceMiddleware } from "./filterPersistence/filterPersistenceMiddleware";

const middleWares = [filterPersistenceMiddleware];

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(middleWares),
});
